<template>
  <v-row>
      <slot></slot>
  </v-row>
</template>

<script>
export default {
  name: "Row"
}
</script>

<style scoped>

</style>